import axios from 'axios'
import serverUrl from '../Utilities/ServerUrl'

// Single shared axios client for the whole app.
// - Request interceptor attaches the *current* token (read fresh from storage
//   every call, so it can never go stale like a captured React state value).
// - Response interceptor turns an expired/invalid token (HTTP 401) into a clean
//   redirect to the login page instead of a silent white screen.
const api = axios.create({
  baseURL: serverUrl,
})

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('authToken')
  if (token) {
    config.headers.Authorization = `Token ${token}`
  }
  return config
})

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Session is no longer valid server-side. Clear the stale token and send
      // the user to login. Guard against a redirect loop if we're already there.
      localStorage.removeItem('authToken')
      localStorage.removeItem('profile')
      if (window.location.pathname !== '/login') {
        window.location.assign('/login')
      }
    }
    return Promise.reject(error)
  }
)

export default api
